import { finalRkpiText } from "./rkpi";

/**
 * Text as it looks once every animation has run, for the PDF: counters at
 * their goal number (it printed 250 as 108 mid-count) and highlights already
 * drawn (they waited to scroll into view, then swept in). Readers and the
 * editor still see them animate.
 */
export const showFinalState = (html: string): string => {
  if (!html || !/data-(rkpi|highlight)-active/.test(html)) return html;
  const doc = new DOMParser().parseFromString(html, "text/html");
  for (const el of Array.from(doc.querySelectorAll("[data-rkpi-active]"))) {
    el.textContent = finalRkpiText(el);
    el.setAttribute("data-rkpi-active", "true");
  }
  for (const el of Array.from(
    doc.querySelectorAll("[data-highlight-active]"),
  )) {
    el.setAttribute("data-highlight-active", "true");
    el.setAttribute("data-highlight-static", "true");
  }
  return doc.body.innerHTML;
};
